module.exports = __webpack_public_path__ + "img/provider_poker.2bc4e946.svg";